<script>
export default {
  name: "AppHero",
  props: {
    kicker: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    titleTag: {
      type: String,
      default: "h2",
    },
    compact: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActions() {
      return Boolean(this.$slots.actions);
    },
    hasAside() {
      return Boolean(this.$slots.aside);
    },
    hasBody() {
      return Boolean(this.$slots.body);
    },
    hasDetails() {
      return Boolean(this.$slots.default);
    },
    heroClasses() {
      return {
        "app-hero--compact": this.compact,
        "app-hero--split": this.hasAside,
        "app-hero--with-body": this.hasBody,
        "app-hero--centered": this.centered,
      };
    },
  },
};
</script>

<template>
  <section class="app-hero" :class="heroClasses">
    <div class="app-hero__body">
      <div class="app-hero__content">
        <span v-if="kicker" class="app-hero__kicker">{{ kicker }}</span>
        <component :is="titleTag" class="section-title">
          <h3>{{ title }}</h3>
        </component>
        <p v-if="description" class="app-hero__description">
          {{ description }}
        </p>

        <div v-if="hasActions" class="app-hero__actions">
          <slot name="actions" />
        </div>
      </div>

      <aside v-if="hasAside" class="app-hero__aside">
        <slot name="aside" />
      </aside>

      <div v-if="hasBody" class="app-hero__main">
        <slot name="body" />
      </div>

      <div v-if="hasDetails" class="app-hero__details">
        <slot />
      </div>
    </div>
  </section>
</template>
<style scoped>

.section-title {
  --dashboard-title: #0f172a;
  margin: 0;
  font-size: 1.35rem;
  color: #0f172a;
}
</style>
